import styled from '@emotion/styled';
import { useTranslationWithPrefix } from '@hotjar/translations';
import type { TableProps } from '@hotjar/hotsauce';
import { Table, Text, tokens } from '@hotjar/hotsauce';

export interface DetailedListItem {
  siteLink: string;
  headerItems: string[];
  items: {
    title: string;
    data: JSX.Element[];
  }[];
  isFirstColumnNarrow?: boolean;
}

const S = {
  Table: styled(Table)<TableProps & { isFirstColumnNarrow?: boolean }>`
    margin-bottom: ${tokens.spacer.x5};
    & td {
      ${(props) => (props.isFirstColumnNarrow ? '&:first-child {width: 20%}' : 'width: 33%')};
    }
  `,
  Cell: styled(Table.Cell)`
    height: 36px;
    padding: 0;
    vertical-align: middle;
  `,
  Text: styled(Text)`
    margin: ${tokens.spacer.x0} 0;
  `,
};

export function DetailedList({
  siteLink,
  headerItems,
  items,
  isFirstColumnNarrow,
}: DetailedListItem): JSX.Element {
  const { t: tSummaryOfChanges } = useTranslationWithPrefix('billing:summary-of-changes');
  return (
    <S.Table
      caption={tSummaryOfChanges('plan-change-list.summary-of-changes-table-for-site', {
        siteLink,
      })}
      tableName={siteLink}
      isFirstColumnNarrow={isFirstColumnNarrow}
    >
      <Table.Head>
        <Table.HeadRow isSticky={false}>
          <S.Cell />
          {headerItems.map((header) => (
            <S.Cell key={header}>
              <S.Text as="p" textType="caption" textColor="text_light">
                {header}
              </S.Text>
            </S.Cell>
          ))}
        </Table.HeadRow>
      </Table.Head>
      <Table.Body>
        {items.map((item) => {
          return (
            <Table.Row key={item.title}>
              <S.Cell align="center" key="title">
                <S.Text as="p" textType="subtitle2">
                  {item.title}
                </S.Text>
              </S.Cell>
              {item.data.map((cell) => (
                <S.Cell align="center" key={cell.key}>
                  {cell}
                </S.Cell>
              ))}
            </Table.Row>
          );
        })}
      </Table.Body>
    </S.Table>
  );
}
